import React from 'react';
import { CircularProgress } from '@mui/material';
import { twMerge } from 'tailwind-merge';

interface LoadingSpinnerProps {
  size?: number;
  color?: string;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 40,
  color = 'text-primary',
  className,
}) => {
  return (
    <div className={twMerge('flex items-center justify-center', className)}>
      <CircularProgress size={size} className={color} />
    </div>
  );
};

export default LoadingSpinner;